module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.exibition_mode')))]), _vm._v(" "), _c('div', {
    staticClass: "box-description"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.how_box_should_display')))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/box-view.svg"),
      "alt": ""
    }
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-bcb3a0fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionmode/Header.vue
 ** module id = 904
 ** module chunks = 1
 **/